import { Link } from 'react-router-dom';
import { Logo } from './Logo.js';

/** Hub de demo: accesos a cada superficie + credenciales. Se llega desde la landing (/). */
export function Acceso() {
  return (
    <div className="landing">
      <p style={{ marginBottom: 18 }}>
        <Link to="/" className="mini">← Volver al sitio</Link>
      </p>

      <div className="hero">
        <div className="logo"><Logo size={52} /></div>
        <h1>Ausentia</h1>
        <p className="mini" style={{ margin: '-8px 0 10px' }}>by AtuelSoft</p>
        <p className="muted">
          Módulo de auditoría en terreno y firma digital · control médico de ausentismo laboral (art. 210 LCT)
        </p>
      </div>

      <div className="accesos">
        <Link className="acceso" to="/login">
          <div className="ic">📋</div>
          <h3>App del médico auditor</h3>
          <p className="muted">Agenda, dictamen de aptitud (apto/no apto), firma del trabajador, firma digital y modo contingencia offline.</p>
        </Link>
        <Link className="acceso" to="/portal/login">
          <div className="ic">🏢</div>
          <h3>Portal de la empresa</h3>
          <p className="muted">Constancias de los controles. RRHH ve el dictamen laboral; Servicio Médico, además las notas reservadas.</p>
        </Link>
        <Link className="acceso" to="/operador/login">
          <div className="ic">💰</div>
          <h3>Panel del operador</h3>
          <p className="muted">Facturación: cuánto cobrar a cada empresa, cuánto pagar a cada profesional y tu ganancia.</p>
        </Link>
      </div>

      <div className="cred">
        <p className="disclaimer">
          Prototipo. La firma digital (PAdES), el sello de tiempo TSA, el PDF/A, la validación REFEPS y la integridad del
          dispositivo están <strong>simulados</strong>; en producción se integran con un certificador licenciado, una TSA
          habilitada y los servicios oficiales. No constituye asesoramiento legal ni un documento con validez jurídica.
        </p>
      </div>
    </div>
  );
}
